import { PlatformSDKShape } from '../PlatformSDKShape';
import { BaseSDKShape } from '../BaseSDKShape';

type ThemeCustomProperty =
  | {
      type: string;
      value: string;
      displayName: string;
    }
  | { error: string };

type FontOption = {
  displayName: string;
  characterSets: string[];
  fontFamily: string;
  cssFontFamily: string;
  style: { weight: number; style: string }[];
};
export class InfoSDKShape extends BaseSDKShape {
  async getViewMode() {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.info.getViewMode();
  }

  async getLanguageCode() {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.info.getLanguageCode();
  }

  async getSiteDirection() {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.info.getSiteDirection();
  }

  async siteHasCustomClasses() {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.info.siteHasCustomClasses();
  }

  async getThemeCustomProperties(filter: {
    keys?: string[];
  }): Promise<Record<string, ThemeCustomProperty>> {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.info.getThemeCustomProperties(filter);
  }

  async getSiteFonts(filter: {
    keys?: string[];
  }): Promise<Record<string, FontOption>> {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.info.getSiteFonts(filter) as Record<string, FontOption>;
  }
}

export default new PlatformSDKShape(InfoSDKShape)
  .withPublicMethod('getViewMode')
  .withPublicMethod('getLanguageCode')
  .withPublicMethod('getSiteDirection')
  .withPublicMethod('siteHasCustomClasses')
  .withPublicMethod('getThemeCustomProperties')
  .withPublicMethod('getSiteFonts')
  .build();
